<template>
  <span class="format-option" :class="{ 'format-option-csv': csv }">
    <span class="format-icon" aria-hidden="true">
      <svg
        width="24"
        height="28"
        viewBox="0 0 24 28"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linejoin="round"
        focusable="false"
      >
        <path d="M3 1.5h11l7 7v18H3zM14 1.5v7h7" />
        <path v-if="csv" d="M6.5 12h11v10h-11zM6.5 17h11M12 12v10" />
        <path
          v-else
          d="M8 13h3m2 0h3M8 22h3m2 0h3M9 13l6 9m0-9l-6 9"
          stroke-width="1.8"
        />
      </svg>
    </span>
    <span class="format-details">
      <span class="format-title">
        <strong>{{ csv ? "CSV" : "Excel" }}</strong>
        <span class="format-speed">
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
            focusable="false"
          >
            <path v-if="csv" d="M3 5l9 7-9 7zM12 5l9 7-9 7z" />
            <template v-else>
              <circle cx="12" cy="12" r="9" />
              <path d="M12 6v6l4 2" />
            </template>
          </svg>
          {{ csv ? "Rápido" : "Más lento" }}
        </span>
      </span>
      <small class="format-description">
        {{
          csv
            ? "Datos sin formato · Archivo ligero"
            : "Hoja de cálculo con formato"
        }}
      </small>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    csv: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.format-option {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  text-align: left;
  white-space: normal;
  background: #fff;
  transition: border-color 0.15s, background-color 0.15s;
}
.format-option-csv {
  border-color: #dbe7fc;
  background: #f4f8ff;
}
.format-option:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}
.format-option-csv:hover {
  border-color: #93b4ee;
  background: #eaf2ff;
}
.format-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  height: 44px;
  border-radius: 10px;
  background: #e9f5ee;
  color: #18794e;
}
.format-option-csv .format-icon {
  background: #e3edff;
  color: #2563eb;
}
.format-details {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.format-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}
.format-title strong {
  color: #263a5b;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
}
.format-speed {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
  padding: 4px 6px;
  border-radius: 6px;
  background: #fff3df;
  color: #946000;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}
.format-option-csv .format-speed {
  background: #deebff;
  color: #1d4ed8;
}
.format-description {
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}
</style>
